// Importing necessary components and libraries from Material UI, React, Redux, and other custom components and utilities
import { Avatar, Box, Card, CardContent, Chip, Divider, Grid, List, ListItem, ListItemAvatar, ListItemText, Paper, Stack, Typography } from '@mui/material';
import MDButton from 'components/MDButton';
import React, { useEffect, useMemo, useState } from 'react';
import StaticsOverview from 'common/StaticsOverview';
import ActiveIcon from 'common/customIcons/active';
import EditIcon from 'common/customIcons/edit';
import InProgressIcon from 'common/customIcons/inprogress';
import AngleRightIcon from 'common/customIcons/angle_right';
import colors from 'assets/theme/base/colors';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPercentage } from 'utilities/common';
import { formatAddressStilo } from 'utilities/common';
import InActiveIcon from 'common/customIcons/inactive';
import { addSpaceBeforeCapital } from 'utilities/common';
import { formatUsPhoneNumber } from 'utilities/common';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { orderDetailStiloStatus } from 'utilities/common';
import defaultProductImage from '../../assets/images/placeholderproduct.svg';
import CartIcon from 'common/customIcons/cart';
import StoreIcon from 'common/customIcons/store';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InventoryIcon from 'common/customIcons/inventory';
import PaymentIcon from 'common/customIcons/payment';
import { LocalShippingOutlined, SupportAgent } from '@mui/icons-material';
import { closeCustomModalDialog, openCustomModalDialog } from '../../redux/slices/modalSlice';
import { openSnackbar } from '../../redux/slices/common';
import { useDispatch } from 'react-redux';
import { fetchSingleOrder, warrantyStatusUpdate } from '../../redux/slices/orders';
import { isEmptyObject } from 'utilities/common';

export default function OrderStiloDetails() {
    const isPos = false
    const { grey } = colors;
    const { order = {}, isLoading = false } = useSelector(state => state.orders)
    const { items, userData, orderId, emailStatus = "", deliveryAddress = {}, trackingId = '', serviceName = '', paymentOption, productPromo } = order
    const { drawerData } = useSelector(state => state.modal)
    const { user = {} } = useSelector(state => state.auth)
    const { orderId: posOrderId } = drawerData || []
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { pathname = '' } = useLocation()
    const [showEmail, setShowEmail] = useState(true)
    const [showPhone, setShowPhone] = useState(true)
    const [anchorEl, setAnchorEl] = useState(false);
    const open = Boolean(anchorEl);
    const isStoreOrder = useMemo(() => {
        return pathname.includes('store-orders')
    }, [pathname])


    useEffect(() => {
        if (isPos) {
            dispatch(fetchSingleOrder(posOrderId))
        }
    }, [isPos])

    useEffect(() => {
        if (!user?.isViewUser) {
            setShowEmail(false)
            setShowPhone(false)
        } else {
            setShowEmail(true)
            setShowPhone(true)
        }
    }, [user?.isViewUser, user])

    const warrantyDialogHandler = (status, orderId, returnItems = []) => {
        // Dispatch the action to open the custom modal dialog with the provided parameters
        dispatch(openCustomModalDialog({ modal: 'WARRANTY_REASON', modalData: { status, orderId, warrantyStatusHanlder, returnItems } }));
    };
    const warrantyStatusHanlder = (data) => {
        // Dispatch the warranty status update action with the provided parameters
        dispatch(warrantyStatusUpdate(data))
            .unwrap()
            .then((res) => {
                // Show success message if the update is successful
                showResponseMessage(res?.message, 'success');
                // Fetch the updated order details
                dispatch(fetchSingleOrder(orderId));
                // Close the custom modal dialog
                dispatch(closeCustomModalDialog());
            })
            .catch((err) => {
                // Show error message if the update fails
                showResponseMessage(err?.message, 'error');
            });
    };
    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
        }
    }


    return (
        <Box p={{ xs: 2, sm: 3, lg: 4 }}>
            {
                !isPos && <Stack direction='row' alignItems='center' justifyContent='space-between' mb={3.5} className='orders-header'>
                    <Box onClick={() => navigate(-1)} sx={{ cursor: 'pointer' }} display="flex" alignItems="center" color='text.main' lineHeight={1} className="res-w-100">
                        <AngleRightIcon fontSize="14px" />
                        <Typography variant='h6' fontWeight="semibold" ml={.75}>Orders</Typography>
                    </Box>
                </Stack>
            }

            <Paper elevation={0} style={{ borderRadius: "12px" }} className="head-paper-columns">
                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="start" justifyContent="space-between" bgcolor="white" p={{ xs: 1, md: 2 }}>
                    <StaticsOverview
                        color="warning"
                        iconShadow="iconShadowWarning"
                        icon={<CartIcon />}
                        title="Order ID"
                        count={orderId}
                    />
                    {
                        trackingId && <StaticsOverview
                            color="primary"
                            iconShadow="iconShadowPrimary"
                            icon={<LocalShippingOutlined />}
                            title="Tracking ID"
                            count={trackingId || '-'}
                        />
                    }
                    {
                        serviceName && <StaticsOverview
                            color="success"
                            iconShadow="iconShadowSuccess"
                            icon={<SupportAgent />}
                            title="Service"
                            count={serviceName || '-'}
                        />
                    }
                    <StaticsOverview
                        color="info"
                        iconShadow="iconShadowInfo"
                        icon={<InventoryIcon />}
                        title="Inventory"
                        count="Safe"
                    />
                    <StaticsOverview
                        color="success"
                        iconShadow="iconShadowSuccess"
                        icon={<StoreIcon />}
                        title="Store"
                        count="Stilo"
                    />
                    <StaticsOverview
                        color="primary"
                        iconShadow="iconShadowInfo"
                        icon={<PaymentIcon />}
                        title="Payment Type"
                        // count={(order?.walletPointsUsed > 0 && ((order?.subTotal - (order?.walletPointsUsed || 0)) > 0 ? (order?.subTotal - (order?.walletPointsUsed || 0))?.toFixed(2) : 0) === 0) ? 'Wallet' : (order?.walletPointsUsed > 0 && (order?.subTotal - order?.walletPointsUsed) > 0) ? 'Credit/Wallet' : "Credit"}
                        count={paymentOption}
                    />
                    {
                        !isLoading &&
                        <StaticsOverview
                            color="#8E0CF5"
                            iconShadow="iconShadowViolet"
                            icon={<InProgressIcon />}
                            title="Status"
                            count={orderDetailStiloStatus?.find((status => status.key === emailStatus))?.value}
                        />
                    }
                </Stack>
            </Paper>

            <Grid container spacing={2.4} my={1}>
                <Grid item xs={12} sm={12} md={isPos ? 12 : 7} lg={isPos ? 12 : 7}>
                    <Card variant='detailsCard'>
                        <CardContent sx={{ p: { xs: 2, md: 3 }, pb: 0 }}>                            
                            {
                                order?.returnItems?.length > 0 && <>
                                    {/* Section for return items */}
                                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={3}>
                                        <Typography variant='h5'>Return Items</Typography>
                                        {
                                            order?.warrantyStatus === 'approved' && <Box color="#24CA49" display="flex" alignItems="center">
                                                <ActiveIcon width="16px" height="16px" flex="none" />
                                                <Typography variant='body2' fontWeight="medium" ml={.5} textTransform="capitalize">Approved</Typography>
                                            </Box>
                                        }
                                        {
                                            order?.warrantyStatus === 'rejected' && <Box color="#FD4438" display="flex" alignItems="center">
                                                <InActiveIcon width="16px" height="16px" flex="none" />
                                                <Typography variant='body2' fontWeight="medium" ml={.5} textTransform="capitalize">Decline</Typography>
                                            </Box>
                                        }
                                        {
                                            !order?.warrantyStatus && <Box display="inline-flex" gap={1} className="invite-action">
                                                <MDButton onClick={() => warrantyDialogHandler(true, orderId, order?.returnItems)} variant='outlined' size='small' color='success' sx={{ fontWeight: 500 }}>Approve</MDButton>
                                                <MDButton onClick={() => warrantyDialogHandler(false, orderId, order?.returnItems)} variant='outlined' size='small' color='error' sx={{ fontWeight: 500 }}>Decline</MDButton>
                                            </Box>
                                        }
                                    </Stack>
                                    {/* List of return items */}
                                    <List className='order-details-listing'>

                                        {
                                            order?.items?.filter((orderProduct =>
                                                order?.returnItems?.find((returnProduct => returnProduct?.productId === orderProduct?.product?.productId)))
                                            )?.map((product => {
                                                const { productId, productImages, productName = '-', category, isSalePrice, salePrice = 0, unitPrice, brandName, customWeight = '' } = product?.product || {};
                                                const { quantity } = product;

                                                const returnItem = order?.returnItems?.find(returnProduct => returnProduct?.productId === productId);
                                                const returnQuantity = returnItem?.quantity || 0;
                                                const approvedItem = order?.approvedItems?.find(item => item?.productId === productId);

                                                return <ListItem key={productId} alignItems="center" sx={{ width: "100%", mt: 2.5, flexDirection: "column" }}>
                                                    <div className='w-100 d-flex'>
                                                        <ListItemAvatar sx={{ mr: 1.5 }} className="pro-avatar-sec">
                                                            <Avatar
                                                                alt="No Image Found"
                                                                src={productImages?.[0] || defaultProductImage}
                                                                sx={{ width: 82, height: 82, borderRadius: 4 }}
                                                            />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={
                                                                <React.Fragment>
                                                                    <Typography variant='body2' color="secondary">{brandName}</Typography>
                                                                    <Link to={`/products/details/${productId}`}>
                                                                        <Typography variant="body2" fontWeight="semibold">{productName}</Typography>
                                                                    </Link>
                                                                    <Typography variant='body2' color="secondary">
                                                                        <span className='mr-3'>Category: <span style={{ color: '#000000' }}>{category?.categoryName}</span></span>
                                                                        <span>Wt: <span style={{ color: '#000000' }}>{customWeight}</span></span>
                                                                    </Typography>
                                                                </React.Fragment>
                                                            }
                                                            secondary={
                                                                <React.Fragment>
                                                                    {
                                                                        !isEmptyObject(productPromo) && productPromo?.productId === productId ? <>
                                                                            <Typography variant="body2" fontWeight="medium" component="span" mr={1}>${((salePrice * quantity) || (unitPrice * quantity)) - productPromo?.price}</Typography>

                                                                            <Typography variant="body2" fontWeight="medium" component="span" color="secondary" mr={1} sx={{ textDecoration: 'line-through' }}>${((salePrice * quantity) || (unitPrice * quantity))}</Typography>

                                                                            <Typography variant="body2" fontWeight="medium" component="span" color="success.main">{getPercentage((salePrice * quantity) || (unitPrice * quantity), salePrice)}% Off</Typography>
                                                                        </> : <>
                                                                            <Typography variant="h6" fontWeight="medium" component="span" mr={1}>${isSalePrice ? salePrice : unitPrice}</Typography>
                                                                            {
                                                                                isSalePrice && <Typography variant="body2" fontWeight="medium" component="span" color="secondary" mr={1} sx={{ textDecoration: 'line-through' }}>${unitPrice}</Typography>
                                                                            }
                                                                            {
                                                                                isSalePrice && getPercentage(unitPrice, salePrice) > 0 && <Typography variant="body2" fontWeight="medium" component="span" color="success.main">{getPercentage(unitPrice, salePrice)}% Off</Typography>
                                                                            }
                                                                        </>
                                                                    }
                                                                    {
                                                                        (order?.promotionData?.promoName && order?.promotionData?.promotionType?.toLowerCase() === 'product' && isSalePrice) || (!isEmptyObject(productPromo) && productPromo?.productId === productId) &&
                                                                        <Box mt={1}>
                                                                            <Chip label="Promo Applied" variant="outlined" color='warning' className='promo-chip chip-square' disabled />
                                                                        </Box>
                                                                    }
                                                                </React.Fragment>
                                                            }
                                                        />
                                                        <Box textAlign="end">
                                                            {
                                                                order?.approvedItems?.length === 0 ?
                                                                    <>
                                                                        {
                                                                            order?.warrantyStatus === 'rejected' ? <Chip label="Rejected" variant="outlined" color='error' className='promo-chip chip-square' /> : order?.warrantyStatus === 'approved' ? <Chip label="Returned" variant="outlined" color='success' className='promo-chip chip-square' /> : null
                                                                        }
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {
                                                                            !approvedItem ?
                                                                                <Chip label="Rejected" variant="outlined" color='warning' className='promo-chip chip-square' /> : <Chip label="Accepted" variant="outlined" color='success' className='promo-chip chip-square' />
                                                                        }
                                                                    </>
                                                            }
                                                        </Box>
                                                    </div>
                                                    <Box mt={1.5} width="100%" display="flex" alignItems="center" gap={1}>
                                                        <Typography variant='body2' fontWeight="semibold" mb={0}>Customer Requested Quantity:</Typography>
                                                        <Typography variant='body2' className='text-left' style={{ marginTop: "2px" }}>x{returnQuantity}</Typography>
                                                    </Box>
                                                    {
                                                        order?.returnComments && <Box mt={1} className="w-100">
                                                            <CardContent className='p-0 text-left'>
                                                                <Typography variant='body2' fontWeight="semibold" mb={0}>Return Request Reason:</Typography>
                                                                <Typography variant='body2' className='text-left'>{order?.returnComments}</Typography>
                                                            </CardContent>
                                                        </Box>
                                                    }
                                                    {
                                                        approvedItem ? <>
                                                            {
                                                                ('proportionalDiscount' in approvedItem && approvedItem.proportionalDiscount !== 0) &&
                                                                <Box mt={1.5} width="100%" display="flex" alignItems="center" gap={1}>
                                                                    <Typography variant='body2' fontWeight="semibold" mb={0}>Proportional Discount:</Typography>
                                                                    <Typography variant='body2' className='text-left' style={{ marginTop: "2px" }}>${approvedItem.proportionalDiscount?.toFixed(2)}</Typography>
                                                                </Box>
                                                            }


                                                        </>
                                                            :
                                                            <>
                                                                {
                                                                    ('proportionalDiscount' in returnItem && returnItem?.proportionalDiscount !== 0) &&
                                                                    <Box mt={1.5} width="100%" display="flex" alignItems="center" gap={1}>
                                                                        <Typography variant='body2' fontWeight="semibold" mb={0}>Proportional Discount:</Typography>
                                                                        <Typography variant='body2' className='text-left' style={{ marginTop: "2px" }}>${returnItem?.proportionalDiscount?.toFixed(2)}</Typography>
                                                                    </Box>
                                                                }
                                                            </>
                                                    }

                                                    {/* Show only if product exists in approvedItems */}
                                                    {approvedItem && (
                                                        <>
                                                            <Box mt={1.5} width="100%" display="flex" alignItems="center" gap={1}>
                                                                <Typography variant='body2' fontWeight="semibold" mb={0}>Return to Stock:</Typography>
                                                                <Typography variant='body2' className='text-left' style={{ marginTop: "2px" }}>{approvedItem.isReturned ? "Yes" : "No"}</Typography>
                                                            </Box>
                                                            <Box mt={1.5} width="100%" display="flex" alignItems="center" gap={1}>
                                                                <Typography variant='body2' fontWeight="semibold" mb={0}>Approved Quantity:</Typography>
                                                                <Typography variant='body2' className='text-left' style={{ marginTop: "2px" }}>x{approvedItem.requestedQty}</Typography>
                                                            </Box>

                                                            <Box mt={1.5} width="100%" className="w-100">
                                                                <Typography variant='body2' fontWeight="semibold" mb={0}>Return Request Reason:</Typography>
                                                                <Typography variant='body2' className='text-left' style={{ marginTop: "2px" }}>{approvedItem.approvalComment}</Typography>
                                                            </Box>
                                                        </>
                                                    )}

                                                </ListItem>;
                                            }))
                                        }
                                    </List>
                                    {
                                        (order?.warrantyStatus === 'rejected' && order?.approvalComment) && <Box mt={3} border={1} borderColor="#9A9AAF" borderRadius={4}>
                                            <CardContent sx={{ px: 3, py: 2 }}>
                                                <Typography variant='body2' fontWeight="semibold">Rejection Reason:</Typography>
                                                <Typography variant='body2'>{order?.approvalComment}</Typography>
                                            </CardContent>
                                        </Box>
                                    }
                                    <Divider sx={{ my: 3 }} />
                                </>
                            }

                            <Typography variant='h5' mb={2}>Product</Typography>
                            <List sx={{ mb: 4 }}>
                                {
                                    items?.map((productItem => {
                                        const { productId, productImages, userData = {}, productName = "-", category, isSalePrice, salePrice, productPrice = 0, unitPrice, proportionalDiscount = '' } = productItem?.product
                                            || {}
                                        const { quantity = 0 } = productItem
                                        return <ListItem key={productId} alignItems="center" sx={{ mt: 2.5 }}>
                                            <ListItemAvatar sx={{ mr: 1.5 }} className="pro-avatar-sec">
                                                <Avatar
                                                    alt="No Image Found"
                                                    src={productImages?.[0] || defaultProductImage}
                                                    sx={{ width: 82, height: 82, borderRadius: 4 }}
                                                />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={
                                                    <React.Fragment>
                                                        <Typography variant='body2' fontWeight="medium" color="secondary">{category?.categoryName}</Typography>
                                                        {
                                                            isPos ? <Typography variant='body2' fontWeight="medium">{productName}</Typography> : <Link className='text-black-900' to={`/products/details/${productId}`}>
                                                                <Typography variant='body2' fontWeight="medium">{productName}</Typography>
                                                            </Link>
                                                        }

                                                    </React.Fragment>
                                                }
                                                secondary={
                                                    <React.Fragment>
                                                        <Typography variant='body2' fontWeight="medium" component="span" mr={1}>${isSalePrice ? salePrice : unitPrice}</Typography>
                                                        {
                                                            isSalePrice && <Typography variant='body2' fontWeight="medium" component="span" color="secondary" mr={1} sx={{ textDecoration: "line-through" }}>${unitPrice}</Typography>
                                                        }
                                                        {
                                                            isSalePrice && getPercentage(unitPrice, salePrice) > 0 && <Typography variant='body2' fontWeight="medium" component="span" color="success.main">{getPercentage(unitPrice, salePrice)}% Off</Typography>
                                                        }
                                                        {
                                                            ('proportionalDiscount' in productItem?.product && proportionalDiscount !== 0) &&
                                                            <Typography variant='body2' color="secondary">
                                                                <span className='mr-3'>Proportional Discount: <span style={{ color: '#000000' }}>${proportionalDiscount}</span></span>
                                                            </Typography>
                                                        }

                                                        {
                                                            order?.promotionData?.promoName && order?.promotionData?.promotionType?.toLowerCase() === 'product' && isSalePrice &&
                                                            <div className="promo-badge">
                                                                <span>Promo Applied</span>
                                                            </div>
                                                        }

                                                    </React.Fragment>
                                                }
                                            />
                                            <Typography variant='body2' mt={5}>x{quantity}</Typography>
                                        </ListItem>
                                    }))
                                }
                            </List>

                            <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Address</Typography>
                            <Typography variant='body2' mb={2} color="secondary">
                                {order?.deliveryAddress?.length !== 0 ? <span>{formatAddressStilo({ ...order?.deliveryAddress, zipcode: order?.deliveryAddress?.zipcode })}</span> : <span>-</span>}
                            </Typography>
                            
                            <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Order Summary</Typography>
                            <List sx={{ py: 2, background: "#F1F1F1", borderRadius: 4 }}>
                                <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                    <ListItemText
                                        primary={
                                            <React.Fragment>
                                                <Typography variant="body2" fontWeight="medium" color="secondary">Order Type</Typography>
                                            </React.Fragment>
                                        }
                                    />
                                    <Typography variant="body2" fontWeight="semibold">{order?.deliveryType}</Typography>
                                </ListItem>
                                {
                                    order?.dropOffOptions &&
                                    <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                        <ListItemText
                                            primary={
                                                <React.Fragment>
                                                    <Typography variant='body2' fontWeight="medium" color="secondary">Drop off option</Typography>
                                                </React.Fragment>
                                            }
                                        />
                                        <Typography variant='body2' fontWeight="semibold">{order?.dropOffOptions ? order?.dropOffOptions === 'meetAtDoor' ? 'Meet At Door' : order?.dropOffOptions === 'discreetCurbside' ? 'Discreet Curbside' : '' : '-'}</Typography>
                                    </ListItem>
                                }

                                <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                    <ListItemText
                                        primary={
                                            <React.Fragment>
                                                <Typography variant='body2' fontWeight="medium" color="secondary">Subtotal</Typography>
                                            </React.Fragment>
                                        }
                                    />
                                    <Typography variant='body2' fontWeight="semibold">${order?.subTotal?.toFixed(2)}</Typography>
                                </ListItem>
                                {
                                    order?.afterTaxDiscount > 0 && <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                        <ListItemText
                                            primary={
                                                <React.Fragment>
                                                    <Typography variant='body2' color="secondary">  Rewards Discount</Typography>
                                                </React.Fragment>
                                            }
                                        />
                                        <Typography variant="body2" style={{ color: '#28B446' }}>
                                            -(${(parseFloat(order && order.afterTaxDiscount).toFixed(2)) || 0})
                                        </Typography>
                                    </ListItem>
                                }
                                {
                                    order?.itemsDiscount > 0 && <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                        <ListItemText
                                            primary={
                                                <React.Fragment>
                                                    <Typography variant='body2' fontWeight="medium" color="secondary">Discount</Typography>
                                                </React.Fragment>
                                            }
                                        />
                                        <Typography className="text-grey-600 font-weight-600 fs-medium text-green-100">-${order?.itemsDiscount?.toFixed(2)}</Typography>
                                    </ListItem>
                                }

                                {
                                    order?.discountType && order?.discountValue > 0 && <>
                                        <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                            <ListItemText
                                                primary={
                                                    <React.Fragment>
                                                        <Typography variant='body2' fontWeight="medium" color="secondary">Discount Type</Typography>
                                                    </React.Fragment>
                                                }
                                            />
                                            <Typography className="text-grey-600 font-weight-600 fs-medium text-green-100 text-capitalize">{order?.discountType}</Typography>
                                        </ListItem>
                                        <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                            <ListItemText
                                                primary={
                                                    <React.Fragment>
                                                        <Typography variant='body2' fontWeight="medium" color="secondary">Sale Discount</Typography>
                                                    </React.Fragment>
                                                }
                                            />
                                            <Typography className="text-grey-600 font-weight-600 fs-medium text-green-100">
                                                {
                                                    `-$${((order?.discountType === 'cash' ? +order?.discountValue : +order?.percentagediscount) || 0)?.toFixed(2)}`
                                                }
                                            </Typography>
                                        </ListItem>
                                    </>
                                }
                                {
                                    order?.promotionData?.promoName && order?.promotionData?.promoDiscount && order?.promotionData?.promotionType !== 'Product' &&
                                    <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                        <ListItemText
                                            primary={
                                                <React.Fragment>
                                                    <Box display='flex' gap={0.5}>
                                                        <Typography variant='body2' fontWeight="medium" color="success.main">{order?.promotionData?.promoName} </Typography>
                                                        <Typography variant='body2' fontWeight="medium" color="secondary" >(Promo code)</Typography>
                                                    </Box>
                                                </React.Fragment>
                                            }
                                        />
                                        <Typography variant='body2' fontWeight="semibold" color="success.main">-${order?.promotionData?.promoDiscount?.toFixed(2)}</Typography>

                                    </ListItem>
                                }
                                <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                    <ListItemText
                                        primary={
                                            <React.Fragment>
                                                <Typography variant='body2' fontWeight="medium" color="secondary">Payment Method</Typography>
                                            </React.Fragment>
                                        }
                                    />
                                    {
                                        order?.total === 0 ?
                                            <Typography variant="body2" fontWeight="semibold" style={{ textTransform: "capitalize" }}>Wallet</Typography>
                                            :
                                            <Typography variant="body2" fontWeight="semibold" style={{ textTransform: "capitalize" }}>{order?.paymentOption}</Typography>

                                    }

                                </ListItem>

                                {
                                    order?.totalTax !== 0 &&
                                    <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                        <ListItemText
                                            primary={
                                                <React.Fragment>
                                                    <Typography variant="body2" color="secondary" display="flex" alignItems="center" gap={0.5}>  Taxes
                                                        <InfoOutlinedIcon className="cur-pointer" onClick={(e) => { e.stopPropagation(); setAnchorEl(!anchorEl); }} />
                                                    </Typography>
                                                </React.Fragment>
                                            }
                                        />
                                        <Typography variant='body2' fontWeight="semibold">${order?.totalTax?.toFixed(2)}</Typography>
                                    </ListItem>
                                }
                                {
                                    open ?
                                        <div className="taxes-break">
                                            <TaxBreakDown
                                                cart={order?.taxDetails}
                                            />
                                        </div>
                                        : null
                                }

                                {
                                    order?.walletPointsUsed > 0 && <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                        <ListItemText
                                            primary={
                                                <React.Fragment>
                                                    <Typography variant='body2' fontWeight="medium" color="secondary">Wallet deducted amount</Typography>
                                                </React.Fragment>
                                            }
                                        />
                                        <Typography variant='body2' fontWeight="semibold" >-${order?.walletPointsUsed?.toFixed(2)}</Typography>
                                    </ListItem>
                                }
                                {
                                    order?.paymentOption?.toLowerCase() === 'split' &&
                                    <>
                                        <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                            <ListItemText
                                                primary={
                                                    <React.Fragment>
                                                        <Typography variant='body2' fontWeight="medium" color="secondary">Cash Payment</Typography>
                                                    </React.Fragment>
                                                }
                                            />
                                            <Typography variant='body2' fontWeight="semibold" >${order?.splitPayment?.cash?.toFixed(2) || 0}</Typography>
                                        </ListItem>
                                        <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                            <ListItemText
                                                primary={
                                                    <React.Fragment>
                                                        <Typography variant='body2' fontWeight="medium" color="secondary">Credit Payment</Typography>
                                                    </React.Fragment>
                                                }
                                            />
                                            <Typography variant='body2' fontWeight="semibold" >${order?.splitPayment?.credit?.toFixed(2)}</Typography>
                                        </ListItem>
                                    </>
                                }
                                {(order?.creditCardDetails?.enabled && order?.creditCardDetails?.ccFee !== undefined && order?.creditCardDetails?.ccFee !== 0) &&
                                    <>
                                        {
                                            (order?.paymentOption?.toLowerCase() !== 'cash' && order?.creditCardDetails) && <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                                <ListItemText
                                                    primary={
                                                        <React.Fragment>
                                                            <Typography variant='body2' fontWeight="medium" color="secondary">{order?.creditCardDetails?.ccReceiptHeading ? order?.creditCardDetails?.ccReceiptHeading : "-"}</Typography>
                                                        </React.Fragment>
                                                    }
                                                />

                                                <Typography variant="body2" fontWeight="semibold" >${order?.creditCardDetails?.ccFee?.toFixed(2)}</Typography>
                                            </ListItem>
                                        }
                                    </>
                                }
                                <Divider sx={{ my: 1 }} />
                                <ListItem alignItems="center" sx={{ px: 3.5, py: 1 }}>
                                    <ListItemText
                                        primary={
                                            <React.Fragment>
                                                <Typography variant='body2' fontWeight="medium">Total Amount Paid</Typography>
                                            </React.Fragment>
                                        }
                                    />
                                    {/* <Typography variant='body2' fontWeight="bold">${order?.total?.toFixed(2)}</Typography> */}
                                   
                                    <Typography variant='body2' fontWeight="bold">${order?.total ? order?.total?.toFixed(2) : 0}</Typography>

                                </ListItem>
                            </List>
                        </CardContent>

                                             {
                            (order?.memo || order?.memo) && <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                                <Typography variant='body2' fontWeight="semibold" mb={1}>Instructions</Typography>
                                <Typography variant='body2'>{order?.memo ? order?.memo : order?.memo}</Typography>
                            </CardContent>
                        }

                    </Card>
                </Grid>

                <Grid item xs={12} sm={12} md={isPos ? 12 : 5} lg={isPos ? 12 : 5}>
                    <Card variant='detailsCard'>
                        <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                            <Typography variant='h5' mb={2}>Member Details</Typography>

                            <Grid container alignItems="center" spacing={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant='caption' color={grey[600]}>Name</Typography>
                                    {
                                        isPos ? <Stack direction='row'>
                                            <Typography variant='body2' fontWeight="medium" lineHeight="1.25">
                                                {userData?.fullName}                                                
                                            </Typography>
                                        </Stack> : <Link className='text-black-900' to={`/members/detail/${userData?.memberId}`}>
                                            <Stack direction='row'>
                                                <Typography variant='body2' fontWeight="medium" lineHeight="1.25">
                                                    {userData?.fullName}                                                    
                                                </Typography>
                                            </Stack>
                                        </Link>
                                    }
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant='caption' color={grey[600]}>Member Address</Typography>
                                    {
                                        userData?.idAddress?.address ? <Typography variant='body2' fontWeight="medium" lineHeight="1.25">{formatAddressStilo({ ...userData?.idAddress, zipcode: userData?.idAddress?.zipcode || userData?.idAddress?.zipCode })}</Typography> : <Typography variant='body2' fontWeight="medium" lineHeight="1.25">-</Typography>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant='caption' color={grey[600]}>Phone</Typography>
                                    <Typography variant='body2' fontWeight="medium" lineHeight="1.25">+1 {userData?.phone ? formatUsPhoneNumber(userData?.phone) : '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Stack direction='row' alignItems='center'>
                                        <Typography variant='body2' color={grey[600]}>Email</Typography>
                                        {/* {!user?.isViewUser && <MemberEmailIconColumn />} */}
                                    </Stack>
                                    <Typography variant='body2' fontWeight="medium">{userData?.email ? showEmail ? userData?.email : userData?.email : '-'}</Typography>                                   
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <Typography variant='caption' color={grey[600]}>Member Type</Typography>
                                    <Typography variant='body2' fontWeight="medium" lineHeight="1.25">{userData?.memberType ? addSpaceBeforeCapital(userData?.memberType) : "-"}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <Typography variant='caption' color={grey[600]}>Member Group</Typography>
                                    <Typography variant='body2' fontWeight="medium" lineHeight="1.25">{userData?.memberShipGroup || '-'}</Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}



function TaxBreakDown({ cart }) {
    const taxData = cart || {}; // assuming taxes are passed inside `cart.taxes`

    return (
        <>
            <Box pl={5} pr={3.5} className='taxes-breakdown'>
                {Object.entries(taxData).map(([taxName, taxAmount]) => (
                    <Typography
                        key={taxName}
                        py={1}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        variant="body2"

                        color="secondary"
                    >
                        <span>{taxName}</span>
                        <Typography typography="body2" color="#000" className="fs-medium">
                            ${taxAmount.toFixed(2)}
                        </Typography>
                    </Typography>
                ))}
            </Box>
        </>
    )
}